import { ParamIds, Places } from '../../../Constants'
import { MainKeys } from '../../../main/Main.keys'

export class GroupManagerKeys extends MainKeys {
    get place() {
        return Places.groupManager
    }

    get groupFilter() {
        return this._intent.getParameterAsString(ParamIds.groupFilter)
    }

    set groupFilter(value: string | undefined) {
        this._intent.setParameter(ParamIds.groupFilter, value)
    }
}

export default GroupManagerKeys
